import React, { FC } from 'react';
import classes from './style/index.module.scss';
import { PublicJobDetailSimilarJob } from '../../types';
import { codes } from '../../../../../data/translations';
import { gray } from '../../../../../components/Color';
import { FlexGrid, FlexGridColumn } from '../../../../../components/FlexGrid';
import { AngleRightSmall } from '../../../../../components/Icons/AngleRightSmall';
import { useTranslationAPI } from '../../../../translations';
import { Typography } from '../../../../../components/Typography';
import { RouteLink } from '../../../../../components/RouteLink';

const PublicJobDetailSimilarJobsCard: FC<React.PropsWithChildren<PublicJobDetailSimilarJob>> = ({
	title,
	shortDescription,
	url,
	formattedAddress,
}) => {
	const { translate } = useTranslationAPI();

	return (
		<FlexGrid
			className={classes.card}
			gap='tiny'
			column
		>
			<FlexGridColumn>
				<Typography
					headingSize={3}
					lineClamp={2}
					bold
					fontSize='16px'
					lineHeight='19px'
				>
					{title}
				</Typography>
			</FlexGridColumn>
			<FlexGridColumn>
				<Typography color={gray[6]}>{formattedAddress}</Typography>
			</FlexGridColumn>
			<FlexGridColumn>
				<Typography lineClamp={6}>{shortDescription}</Typography>
			</FlexGridColumn>
			<FlexGridColumn
				noGrow
				wrappedText
				end
				vrEnd
			>
				<RouteLink
					link
					styledButton
					size={'small'}
					endIcon={<AngleRightSmall />}
					href={url}
				>
					{translate(codes.more)}
				</RouteLink>
			</FlexGridColumn>
		</FlexGrid>
	);
};

export { PublicJobDetailSimilarJobsCard };
